import { useEffect } from "react";
import { useAlert } from "../../providers/AlertProvider";
import { useLocation } from "react-router-dom";
import CustomAlert from "./CustomAlert";
import { scrollToTop } from "../../lib/PageUtils";

export default function Alerts() {
    const location = useLocation();
    const alertApi = useAlert();
  
    useEffect(() => {
        alertApi.clear();
    }, [location]);

    useEffect(() => {
        if (alertApi.alerts.length > 0) {
            scrollToTop();
        }
    }, [alertApi.alerts.length]);
    
    return (
        <div>
            {alertApi.alerts.map((alert, i) =>
                <CustomAlert key={i} alert={alert} onClose={() => alertApi.remove(alert)}/>
            )}
        </div>
    );
}